import { api } from './axios'

export interface Municipio {
  codigoIbge: number
  nome: string
}

export async function getMunicipios(uf: string): Promise<Municipio[]> {
  const response = await api.get<Municipio[]>('/matriculas/municipios', { params: { uf } })
  return response.data
}
